var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-schema',{attrs:{"model":_vm.model}},[_c('v-text-field',_vm._g(_vm._b({attrs:{"name":_vm.name,"label":_vm.label,"type":_vm.type}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }